import { t } from 'ttag'
import styled from 'styled-components'

import { ProgressBar } from '@h2/components/display/progressBar'
import { Flex } from '@h2/components/layout/flex'
import { Heading } from '@h2/components/typography/heading'
import { PB90T } from '@h2/components/colors'

const StyledHeading = styled(Heading)`
  display: flex;
  justify-content: space-between;
`
const PlanProgress = ({ progress: { lessonsInSequence, lessonsComplete } }) => {
  const difference = lessonsComplete / lessonsInSequence
  const percent = difference !== Infinity ? Math.round(100 * difference) : 0

  return (
    <Flex direction="column" justifyContent="center" grow={1} gap="5px">
      <StyledHeading level="5" removeMargins={true} variant="mixed-weight">
        {t`Progress: `}
        <span>{`${percent}%`}</span>
      </StyledHeading>

      <ProgressBar size="large" display="green" value={percent} bgColor={PB90T} />
    </Flex>
  )
}

export { PlanProgress }
